export enum EFiltersActions {
  SET_DEAL_TYPE_REALTORS = 'filters/setDealTypeRealtors',
  SET_DEAL_TYPE_AGENCIES = 'filters/setDealTypeAgencies',

  SET_OFFER_TYPE_REALTORS = 'filters/setOfferTypeRealtors',
  SET_OFFER_TYPE_AGENCIES = 'filters/setOfferTypeAgencies',

  SET_SORT_BY_REALTORS = 'filters/setSortByRealtors',
  SET_SORT_BY_AGENCIES = 'filters/setSortByAgencies',

  SET_SEARCH_TEXT_REALTORS = 'filters/setSearchTextRealtros',
  SET_SEARCH_TEXT_AGENCIES = 'filters/setSearchTextAgencies',
}
